import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../Services/Axios/Api';
import { clearLocalStorage, clearSessionStorage, setAdminToken, setToken } from '../Services/Axios/axiosInstance';
const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState(() => {
        // Check localStorage for existing auth state when initializing
        const storedAuth = localStorage.getItem('isAdmin');
        return storedAuth ? JSON.parse(storedAuth) : false;
    });

    const [isLoggedIn, setIsLoggedIn] = useState(() => {
        return localStorage.getItem('isLoggedIn') === 'true';
    });

    const checkDonorLogin = () => {
        setIsLoggedIn(localStorage.getItem('isLoggedIn') === 'true');
    };

    const login = async(email, password) => {
        try {
            const response = await AuthService.MasterUserLogin(email, password);
            if (response.isSuccess) {
                setIsAdmin(true);
                // Store auth state in localStorage
                localStorage.setItem('isAdmin', 'true');
                setToken(response.result.accessToken)
                navigate("/bj-admin");
            } else {
                setIsAdmin(false);
                localStorage.removeItem('isAdmin');
            }
        } catch (error) {
            throw new Error(error.message);
        }
    };

    const logout = () => {
        setIsAdmin(false);
        // Remove auth state from localStorage
        localStorage.removeItem('isAdmin');
        clearLocalStorage();
        clearSessionStorage();
        navigate("/bj-login");
    };

    // Optional: You might want to add an auto-logout after some time
    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'isAdmin') {
                setIsAdmin(e.newValue ? JSON.parse(e.newValue) : false);
            }
            if (e.key === 'isLoggedIn') {
                setIsLoggedIn(e.newValue === 'true');
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('authChange', checkDonorLogin);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('authChange', checkDonorLogin);
        };
    }, []);

    return (
        <AuthContext.Provider value={{ isAdmin, login, logout, isLoggedIn, checkDonorLogin }}>
            {children}
        </AuthContext.Provider>
    );
};